export default "./src/client/components/auth/login/open-web/spid-button/img/spid-idp-sielteid.svg?213ad584e0d8495f56b2e86bff684eda";